/**
 * 팀 관리 명단의 「하위 팀 포함」 기억(2026-10-12 사용자 요청) — 기본 **켬**, 바꾸면 조직·사용자별로 localStorage 에 남겨
 * 다른 팀으로 옮겨도 그대로 유지한다. 예전엔 기본 꺼짐이고 팀을 바꿀 때마다 꺼져, 상위 팀을 돌아다닐 때마다 다시 켜야 했다.
 * 표시 필터일 뿐 권한과 무관(MED-945).
 */
const PREFIX = "hereby:admin:teamRoster:includeSubteams";

export function rosterIncludeSubteamsKey(
  organizationId?: string | null,
  userId?: string | null,
): string {
  return `${PREFIX}:${organizationId || "org"}:${userId || "me"}`;
}

/** 저장값이 없거나 깨졌으면 기본 켬 */
export function parseIncludeSubteams(raw: string | null | undefined): boolean {
  if (raw === "0" || raw === "false") {
    return false;
  }
  return true;
}

export function readIncludeSubteams(key: string): boolean {
  try {
    return parseIncludeSubteams(localStorage.getItem(key));
  } catch {
    return true;
  }
}

export function writeIncludeSubteams(key: string, value: boolean): void {
  try {
    localStorage.setItem(key, value ? "1" : "0");
  } catch {
    // 사생활 모드·용량 초과 — 기억만 포기한다
  }
}
